import React, { Component } from "react";

export default class GuestFooter extends Component {

  render() {

    const date = new Date();
    const year = date.getFullYear();

    return (
      <div className="footer-activation">
        <div className="footer-activation-container">

          <div className="footer-menu">
            <a
              href="https://telsim.com.au/website-privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Privacy Policy |
            </a>

            <a
              href="https://telsim.com.au/legals"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Legals |
            </a>

            <a
              href="https://telsim.com.au/contact-us"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Contact Us
            </a>
          </div>

          <div className="footer-copyright">
            Copyright © {year} | Telsim | All Rights Reserved
          </div>

        </div>
      </div>
    );
  }
}